// @spec DHB-STR-041
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { QualityIssuesPage } from '@/features/datahub/components/QualityIssuesPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/quality-issues')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.qualityIssues'),
  }),
  component: QualityIssuesPage,
});
